define(
({
  "load_error": "Betöltési hiba",
  "description": "Egy kérelem nem teljesült megfelelően. Ellenőrizd, hogy a rendelésed mentésre került-e, majd frissítsd ezt az oldalt."
})
);
